import { mapGetters, mapState } from 'vuex';

export default {
    computed: {
        ...mapState('core', ['loading', 'error', 'apiUrl', 'mediainfoUrl', 'uploadOptions', 'imageUrl']),
        ...mapGetters('core', ['routes', 'welcome', 'home', 'forbidden', 'shouldGrantAccess']),
    },
};
